import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
// import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import HotelsList from '../../components/BookingHistoryList/list';

const BookingHistoryPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <HotelsList />
            {/* <Footer footerClass={'wpo-ne-footer-2'}/> */}
            <Scrollbar/>
        </Fragment>
    )
};
export default BookingHistoryPage;